import cogoToast from 'cogo-toast';
import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  DOWNLOAD_UTILITY_SAMPLE_EXCEL,
  DOWNLOAD_UTILITY_SAMPLE_EXCEL_SUCCESS,
  DOWNLOAD_UTILITY_SAMPLE_EXCEL_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* downloadUtilitySampleExcel({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/sample-excel`,
      method: 'GET',
      params: { issue_type: payload.issueType },
      headers: filteredHeaders,
      isOctetStream: true,
    });

    if (response.status === 200) {
      const blob = new Blob([response.data], {
        type: response.headers?.['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `sample_${payload.issueType || 'template'}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      yield put({ type: DOWNLOAD_UTILITY_SAMPLE_EXCEL_SUCCESS, payload: true });
    } else {
      cogoToast.error(response?.response?.data?.message || 'Download failed');
      yield put({ type: DOWNLOAD_UTILITY_SAMPLE_EXCEL_ERROR, payload: response?.response?.data?.message });
    }
  } catch (error) {
    cogoToast.error('Download failed');
    yield put({ type: DOWNLOAD_UTILITY_SAMPLE_EXCEL_ERROR, payload: error });
  }
}

export function* watchDownloadUtilitySampleExcel() {
  yield takeLatest(DOWNLOAD_UTILITY_SAMPLE_EXCEL, downloadUtilitySampleExcel);
}

function* downloadUtilitySampleExcelSaga() {
  yield all([fork(watchDownloadUtilitySampleExcel)]);
}

export default downloadUtilitySampleExcelSaga;
